module.exports = __webpack_public_path__ + "static/media/3.50b1e11c.jpeg";